
const initialState = {
  loading: false,
  newPass: false,
  error: false,
  paymentOptionListing: [],
  paymentOptionDetail: null
};

const paymentOptionReducer = (state = initialState, action) => {
  // console.log("privacy  reducers------", state, action);
  switch (action.type) {
    case "ADD_PAYMENT_OPTION_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "ADD_PAYMENT_OPTION_SUCCESS":
      return {
        ...state,
        loading: false,
        newPass: true,
        error: false,
      };
    case "ADD_PAYMENT_OPTION_FAILED":
      return {
        ...state,
        loading: false,
        newPass: false,
        error: true,
      };

    case "GET_PAYMENT_OPTION_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_PAYMENT_OPTION_REQUEST_FAILED":
      return {
        ...state,
        error: true,
      };
    case "GET_PAYMENT_OPTION_REQUEST_SUCCESS":
      return {
        ...state,
        paymentOptionListing: action.payload,
        loading: false,
      };


    case "GOT_PAYMENT_OPTION_DETAIL":
      return {
        ...state,
        paymentOptionDetail: action.payload,
      };
    default:
      return state;
  }
};

export default paymentOptionReducer;
